import React, { forwardRef } from "react";
import "./MelaCheckbox.css";

export interface MelaCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  label?: React.ReactNode;
  /** Rendered under the control, outside the clickable label. */
  helperText?: React.ReactNode;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  dataTestId?: string;
}

export const MelaCheckbox = forwardRef<HTMLInputElement, MelaCheckboxProps>(
  (
    {
      label,
      helperText,
      disabled = false,
      containerClassName,
      containerStyle,
      dataTestId,
      ...inputProps
    },
    ref,
  ) => (
    <div
      data-mela-check="true"
      className={containerClassName}
      style={containerStyle}
    >
      <label
        className={`mela-check__control ${disabled ? "mela-check__control--disabled" : ""}`}
      >
        <input
          {...inputProps}
          ref={ref}
          type="checkbox"
          disabled={disabled}
          className="mela-check__input"
          data-testid={dataTestId}
        />
        <span className="mela-checkbox__box" aria-hidden="true">
          <svg viewBox="0 0 12 12" fill="none">
            <path
              d="M2.5 6.2 5 8.5 9.5 3.5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        {label}
      </label>
      {helperText && <span className="mela-check__helper">{helperText}</span>}
    </div>
  ),
);

MelaCheckbox.displayName = "MelaCheckbox";
